import { render, staticRenderFns } from "./ProviderContactsTag.vue?vue&type=template&id=6d9f86a0"
import script from "./ProviderContactsTag.vue?vue&type=script&lang=js"
export * from "./ProviderContactsTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports